import React from 'react';
import { IconType } from 'components/Icon/constants';
import EditorToolbarButton from '../EditorToolbarButton';

type Props = {
  isNoWrapActive: boolean;
  onToggle: () => void;
  dataTestId?: string;
};

const WrapControl: React.FunctionComponent<Props> = ({ isNoWrapActive, onToggle, dataTestId = 'wrapControl' }) => (
  <EditorToolbarButton
    active={isNoWrapActive}
    label={IconType.NO_WRAP}
    onToggle={onToggle}
    value={''}
    title={'NoWrap'}
    dataTestId={`${dataTestId}-editorToolbarButton`}
  />
);

export default WrapControl;
